<mat-card>
  <mat-card-header>
    <mat-card-title style="margin-bottom: 16px"
      >Légende des couleurs</mat-card-title
    >
    <mat-card-subtitle style="margin-bottom: 16px"
      >Signification des couleurs affichées dans le tableau</mat-card-subtitle
    >
  </mat-card-header>

  <mat-card-content>
    <table mat-table [dataSource]="legendItems" class="mat-elevation-z8">
      <!-- Colonne couleur ou icône -->
      <ng-container matColumnDef="color">
        <th mat-header-cell *matHeaderCellDef>Couleur/Icon</th>
        <td mat-cell *matCellDef="let element">
          @if (element.icon) {
          <ng-container>
            <mat-icon [style.color]="element.color" class="color-icon">{{
              element.icon
            }}</mat-icon>
          </ng-container>
          } @else {
          <div class="color-icon" [style.backgroundColor]="element.color"></div>
          }
        </td>
      </ng-container>

      <!-- Colonne label -->
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>Signification</th>
        <td mat-cell *matCellDef="let element">{{ element.label }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card-content>
</mat-card>
